export default "__VITE_ASSET__XjDjLJV$__"